module.exports = __webpack_public_path__ + "static/media/my-progress.5ed0dc4c.svg";